import PropTypes from "prop-types";
import SortDropdown from "../../../../components/DropDownComponent";
import { useRewampT } from "../../../localisation";
import FilterSelectControl from "./FilterSelectControl";

export default function FilterSortField({ controlId, labelKey, label, options, value, onChange, compact, dropdownVariant }) {
  const tRewamp = useRewampT();
  const resolvedLabel = label || (labelKey ? tRewamp(labelKey) : "");
  // Dropdown variant → rewamp Select on the trigger part (label comes from the cell); otherwise the
  // legacy CustomDropdown, untouched for its other consumers.
  if (dropdownVariant) {
    return (
      <FilterSelectControl
        controlId={controlId}
        ariaLabel={resolvedLabel}
        options={options}
        value={value}
        onChange={onChange}
        dropdownVariant={dropdownVariant}
      />
    );
  }
  return (
    <SortDropdown
      compact={compact}
      label={resolvedLabel}
      translateLabel={false}
      options={options}
      prefilledValue={value}
      onChange={onChange}
    />
  );
}

FilterSortField.propTypes = {
  labelKey: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  compact: PropTypes.bool,
  controlId: PropTypes.string,
  dropdownVariant: PropTypes.string,
};

FilterSortField.defaultProps = {
  controlId: undefined,
  dropdownVariant: undefined,
  labelKey: null,
  label: null,
  options: [],
  value: "",
  compact: true,
};
